import React from 'react';
import { ActivateProductConnectorApollo } from '@front-activerse/common-components';
import ActivateProductContainer from './ActivateProductContainer';

const ActivateProductPage: React.FC = () => (
  <ActivateProductConnectorApollo>
    {({ activateProduct }) => <ActivateProductContainer activateProduct={activateProduct} />}
  </ActivateProductConnectorApollo>
);

export default ActivateProductPage;
